import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/esm/Container';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import DoneIcon from '@mui/icons-material/Done';
import { Box, TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
  GetOneClientAction,
  UpdateClientAction,
  UpdateStageToLeed,
} from '../Redux/Actions/UsersAction';
import { Link, useParams } from 'react-router-dom';
import { Notify } from '../Utility/Notify';
import { GetAll_stage_Data, GetOne_stagetogettype_Data } from '../Redux/Actions/Stage_Action';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { GetAll_CancelReasons_Data } from '../Redux/Actions/CancelReasons_Actions';
import { Insert_Lead_Stages_Data_Action } from '../Redux/Actions/Lead_Stages_Changed_Action';
import { Col, Row, Spinner } from 'react-bootstrap';
import JSConfetti from 'js-confetti';

export const UpdateStage = () => {
  const dispatch = useDispatch();
  const { id, salesID } = useParams();
  const [userlogin, setuserlogin] = useState('');
  useEffect(() => {
    if (JSON.parse(localStorage.getItem('user')) != null) {
      setuserlogin(JSON.parse(localStorage.getItem('user')));
    }
  }, []);

  const [date, setDate] = useState('');
  const [dateonly, setDateonly] = useState('');
  const [startDate, setStartDate] = useState(new Date());
  const [stage, setstage] = useState('');
  const [loading, setloading] = useState();
  const [cancelreason, setcancelreasons] = useState('');

  // States الجديدة للسعر
  const [unitPrice, setUnitPrice] = useState('');
  const [isPriceValid, setIsPriceValid] = useState(false);
  const [unitnumber, setunitnumber] = useState('');
  const [isunitnumberValid, setisunitnumberValid] = useState(false);
  const [commissionRatio, setcommissionratio] = useState('');
  const [commissionratioValid, setIscommissionratioValid] = useState(false);
  const [totalCommission, setTotalCommission] = useState('');
  const [cahbackratiovalid, setiscashbackratiovalid] = useState(false);
  const [cashbackratio, setcashbackratio] = useState('');
  const [cashbackMoney, setCashbackMoney] = useState('');

  const [eoiAmount, setEoiAmount] = useState('');
  const [reservationAmount, setReservationAmount] = useState('');
  const [isEoiAmountValid, setIsEoiAmountValid] = useState(false);
  const [isReservationAmountValid, setIsReservationAmountValid] = useState(false);

  const handleEoiAmountChange = (e) => {
    const value = e.target.value;
    setEoiAmount(value);
    const amount = parseFloat(value);
    setIsEoiAmountValid(!isNaN(amount) && amount > 0);
  };

  const handleReservationAmountChange = (e) => {
    const value = e.target.value;
    setReservationAmount(value);
    const amount = parseFloat(value);
    setIsReservationAmountValid(!isNaN(amount) && amount > 0);
  };

  useEffect(() => {
    if (id) {
      dispatch(GetOneClientAction(id));
    }
  }, [id]);

  const selectedlead = useSelector((state) => state.Allusers.Get_users);

  // console.log(selectedlead,"selectedlead")

  useEffect(() => {
    const price = parseFloat(unitPrice);
    const ratio = parseFloat(commissionRatio);

    if (!isNaN(price) && !isNaN(ratio) && price > 0 && ratio > 0) {
      const commission = (price * ratio) / 100;
      setTotalCommission(commission.toFixed(2));
    } else {
      setTotalCommission('');
    }
  }, [unitPrice, commissionRatio]);

  useEffect(() => {
    const price = parseFloat(unitPrice);
    const ratio = parseFloat(cashbackratio);

    if (!isNaN(price) && !isNaN(ratio) && price > 0 && ratio > 0) {
      const cashback = (totalCommission * ratio) / 100;
      setCashbackMoney(cashback.toFixed(2));
    } else {
      setCashbackMoney('');
    }
  }, [totalCommission, cashbackratio]);

  useEffect(() => {
    const today = new Date();
    const formattedDateandtime = today.toLocaleDateString();
    setDate(formattedDateandtime);

    const todaydayonly = new Date();
    const formattedDateonly = `${todaydayonly.getFullYear()}-${(todaydayonly.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${todaydayonly.getDate().toString().padStart(2, '0')}`;
    setDateonly(formattedDateonly);
  }, []);

  const handleChange = (date) => {
    setStartDate(date);
    const formattedDateTime = `${date.toLocaleDateString('en-US')} ${date.toLocaleTimeString(
      'en-US',
      {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      },
    )}`;
  };

  useEffect(() => {
    const run = async () => {
      await dispatch(GetAll_stage_Data());
    };
    run();
  }, [dispatch]);

  const resgetallstages = useSelector((state) => state.Allstages.stage);
  let res_getallstages_array = Array.isArray(resgetallstages?.data) ? resgetallstages.data : [];

  let selectedStageName;
  const onstagechange = (e) => {
    const selectedStageId = e.target.value;
    setstage(selectedStageId);
    setIsPriceValid(false);
    setIscommissionratioValid(false);
    setiscashbackratiovalid(false);

    setisunitnumberValid(false);
    // البحث عن المرحلة المحددة للحصول على الاسم
    const selectedStage = res_getallstages_array.find((s) => s._id === selectedStageId);
    const currentStageName = selectedStage?.name;

    // إذا كانت المرحلة ليست Done Deal، نعيد تعيين سعر الوحدة
    if (currentStageName !== 'Done Deal') {
      setUnitPrice('');
      setunitnumber('');
      setcommissionratio('');
      setcashbackratio('');
    }
  };

  useEffect(() => {
    if (stage) {
      dispatch(GetOne_stagetogettype_Data(stage));
    }
  }, [stage, dispatch]);

  const resgetonestagetype = useSelector((state) => state.Allstages.getstagetogetype);
  let onetype_of_stage = [];
  if (resgetonestagetype && resgetonestagetype.data) {
    onetype_of_stage = resgetonestagetype.data;
  } else {
    onetype_of_stage = [];
  }

  const jsConfetti = new JSConfetti();

  function DoneDealFun() {
    jsConfetti.addConfetti({
      confettiColors: ['#ff0a54', '#ff477e', '#ff7096', '#ff85a1', '#fbb1bd', '#f9bec7'],
    });
  }

  // دالة التحقق من السعر
  const handlePriceChange = (e) => {
    const value = e.target.value;
    setUnitPrice(value);
    const price = parseFloat(value);
    setIsPriceValid(!isNaN(price) && price > 0);
  };

  const handleunitnumber = (e) => {
    setunitnumber(e.target.value);
  };

  const handlecommissionratioChange = (e) => {
    const value = e.target.value;
    setcommissionratio(value);
    const commissionratio = parseFloat(value);
    setIscommissionratioValid(!isNaN(commissionratio) && commissionratio > 0);
  };

  const handlecashbackratiochange = (e) => {
    const value = e.target.value;
    setcashbackratio(value);
    const cashbackratio = parseFloat(value);
    setiscashbackratiovalid(!isNaN(cashbackratio) && cashbackratio > 0);
  };

  const updatestage = async (e) => {
    e.preventDefault();

    const selectedStage = res_getallstages_array.find((s) => s._id === stage);
    const currentStageName = selectedStage?.name;

    if (selectedlead?.data?.stage?.name === 'Done Deal' && currentStageName === 'Done Deal') {
      Notify('error', 'Current stage is Done Deal, not allowed to update', 'error');
      return;
    }
    if (!selectedStage) {
      Notify('error', 'لم يتم العثور على المرحلة المختارة', 'error');
      return;
    }

    // التحقق من صحة المبالغ في EOI و Reservation
    if (currentStageName === 'EOI' && (!isEoiAmountValid || eoiAmount === '')) {
      Notify('error', 'Please enter a valid EOI amount', 'error');
      return;
    }

    if (
      currentStageName === 'Reservation' &&
      (!isReservationAmountValid || reservationAmount === '')
    ) {
      Notify('error', 'Please enter a valid Reservation amount', 'error');
      return;
    }

    if (currentStageName === 'Done Deal') {
      const price = parseFloat(unitPrice);
      if (isNaN(price) || price <= 0) {
        Notify('error', 'يجب إدخال سعر وحدة صالح (أكبر من صفر)', 'error');
        return;
      }
    }

    setloading(true);

    try {
      const updateData = {
        stage: stage,
        stagedateupdated: startDate.toISOString(),
        last_stage_date_updated: dateonly,
        ...(selectedStage.name === 'Done Deal' && {
          unit_price: parseFloat(unitPrice),
          review: false,
          unitnumber: unitnumber,
          commissionratio: parseFloat(commissionRatio),
          commissionmoney: totalCommission,
          cashbackratio: parseFloat(cashbackratio),
          cashbackmoney: cashbackMoney,
        }),

        ...(selectedStage.name === 'EOI' && {
          Eoi: parseFloat(eoiAmount),
        }),
        ...(selectedStage.name === 'Reservation' && {
          Reservation: parseFloat(reservationAmount),
        }),
      };

      // console.log("updateData:", updateData);

      await dispatch(UpdateStageToLeed(id, updateData));

      const leadStageData = {
        LeadId: id,
        date: dateonly,
        stage: selectedStage._id,
        sales: salesID,
        dateselectedforstage: startDate,
        ...(currentStageName === 'Done Deal' && {
          unitPrice: parseFloat(unitPrice),
        }),
      };

      await dispatch(Insert_Lead_Stages_Data_Action(leadStageData));

      if (selectedStage.name === 'Done Deal') {
        DoneDealFun();
      }

      Notify('success', 'تم تحديث المرحلة بنجاح', 'success');
    } catch (error) {
      console.error('Error updating stage:', error);
      Notify('error', 'حدث خطأ أثناء تحديث المرحلة', 'error');
    } finally {
      setloading(false);
    }
  };

  const resupdate = useSelector((state) => state.Allusers.Get_users);
  const stageName = resupdate?.data?.data?.stage?.name || 'Unknown Stage';

  useEffect(() => {
    if (loading === false) {
      if (resupdate && resupdate.status === 200) {
        // if (stageName === "Done Deal") {
        //   DoneDealFun();
        // }
        Notify('success', 'Successfully Stage Updated', 'success');
      } else {
        Notify('error', 'Failed to Update Stage', 'error');
        return;
      }
    }
  }, [loading, resupdate, stageName]);

  const CancelReasonschange = (e) => {
    setcancelreasons(e.target.value);
  };

  useEffect(() => {
    const getallreasons = async () => {
      await dispatch(GetAll_CancelReasons_Data());
    };
    getallreasons();
  }, [dispatch]);

  const res_all_reasons = useSelector((state) => state.AllCancelReasons.Cancelreason);
  let res_allcancelreasons_array = Array.isArray(res_all_reasons?.data) ? res_all_reasons.data : [];

  // تحديد إذا كان الزر معطلاً (لـ Done Deal فقط)
  const isSubmitDisabled =
    stageName === 'Done Deal' &&
    !isPriceValid &&
    !isunitnumberValid &&
    !commissionratioValid &&
    !cahbackratiovalid;

  let homePath = null;

  if (userlogin) {
    switch (userlogin?.data?.role) {
      case 'Admin':
        homePath = '/AllLeadsForAdmin';
        break;
      case 'Sales':
        homePath = '/AllLeadsForSales';
        break;
      case 'Team Leader':
        homePath = '/AllLeadsForTeamLeader';
        break;
      case 'Marketer':
        homePath = '/ALLLeadsForMarketer';
        break;
      case 'Manager':
        homePath = '/LeadsForManagers';
        break;
      default:
        homePath = null;
    }
  }

  return (
    <div>
      <Container className="startpage">
        <Row>
          <Col sm={2}></Col>
          <Col sm={10}>
            <div
              className="d-flex flex-wrap align-items-center mb-3"
              style={{ gap: '0.5rem', fontSize: '1.1rem' }}
            >
              {homePath ? (
                <Link
                  to={homePath}
                  style={{
                    textDecoration: 'none',
                    color: '#102dff',
                    fontWeight: 'bold',
                  }}
                >
                  Home
                </Link>
              ) : null}

              <KeyboardDoubleArrowRightIcon style={{ color: '#666' }} />
              <span style={{ color: '#333' }}>Update Stage</span>
            </div>

            <div>
              <p style={{ color: '#102dff' }}>
                Current Stage :
                {selectedlead?.data?.stage?.name ? (
                  selectedlead.data.stage.name
                ) : (
                  <Spinner animation="border" size="sm" style={{ marginLeft: '8px' }} />
                )}
              </p>
            </div>
            <hr />
            <div className="my-2" style={{ width: '100%', textAlign: 'center' }}>
              Choose stage
            </div>
            <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Choose Stage</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={stage}
                  label="choose stage"
                  onChange={onstagechange}
                >
                  {res_getallstages_array.map((item, index) => {
                    return (
                      <MenuItem key={index} value={item._id}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Box>

            {/* Archive */}
            {onetype_of_stage &&
            onetype_of_stage.stagetype &&
            onetype_of_stage.stagetype.name === 'Archive' ? (
              <div>
                <div style={{ width: '100%' }}>
                  <DatePicker
                    selected={startDate}
                    onChange={handleChange}
                    showTimeSelect
                    timeFormat="hh:mm aa"
                    timeIntervals={1}
                    dateFormat="Pp"
                    className="form-control dtp"
                  />
                </div>
              </div>
            ) : null}

            {/* EOI */}
            {onetype_of_stage &&
            onetype_of_stage.stagetype &&
            onetype_of_stage.stagetype.name === 'EOI' ? (
              <div>
                {/* <div style={{ width: '100%' }}>
      <DatePicker
        selected={startDate}
        onChange={handleChange}
        showTimeSelect
        timeFormat="hh:mm aa"
        timeIntervals={1}
        dateFormat="Pp"
        className="form-control dtp"
      />
    </div> */}
                <div className="mt-3">
                  <FormControl fullWidth margin="normal">
                    <TextField
                      id="eoi-amount"
                      label="Amount (AED)"
                      type="number"
                      value={eoiAmount}
                      onChange={handleEoiAmountChange}
                      variant="outlined"
                      required
                      error={!isEoiAmountValid && eoiAmount !== ''}
                      helperText={
                        !isEoiAmountValid && eoiAmount !== ''
                          ? 'Please enter a valid amount'
                          : eoiAmount === ''
                            ? 'Please enter the amount in AED'
                            : ''
                      }
                      inputProps={{
                        min: 0.01,
                        step: 0.01,
                      }}
                    />
                  </FormControl>
                </div>
              </div>
            ) : null}

            {/* Reservation */}
            {onetype_of_stage &&
            onetype_of_stage.stagetype &&
            onetype_of_stage.stagetype.name === 'Reservation' ? (
              <div>
                {/* <div style={{ width: '100%' }}>
      <DatePicker
        selected={startDate}
        onChange={handleChange}
        showTimeSelect
        timeFormat="hh:mm aa"
        timeIntervals={1}
        dateFormat="Pp"
        className="form-control dtp"
      />
    </div> */}
                <div className="mt-3">
                  <FormControl fullWidth margin="normal">
                    <TextField
                      id="reservation-amount"
                      label="Amount (AED)"
                      type="number"
                      value={reservationAmount}
                      onChange={handleReservationAmountChange}
                      variant="outlined"
                      required
                      error={!isReservationAmountValid && reservationAmount !== ''}
                      helperText={
                        !isReservationAmountValid && reservationAmount !== ''
                          ? 'Please enter a valid amount'
                          : reservationAmount === ''
                            ? 'Please enter the amount in AED'
                            : ''
                      }
                      inputProps={{
                        min: 0.01,
                        step: 0.01,
                      }}
                    />
                  </FormControl>
                </div>
              </div>
            ) : null}

            {/* Rent */}
            {onetype_of_stage &&
            onetype_of_stage.stagetype &&
            onetype_of_stage.stagetype.name === 'Rent' ? (
              <div>
                <div style={{ width: '100%' }}>
                  <DatePicker
                    selected={startDate}
                    onChange={handleChange}
                    showTimeSelect
                    timeFormat="hh:mm aa"
                    timeIntervals={1}
                    dateFormat="Pp"
                    className="form-control dtp"
                  />
                </div>
              </div>
            ) : null}

            {/* Hold */}
            {onetype_of_stage &&
            onetype_of_stage.stagetype &&
            onetype_of_stage.stagetype.name === 'Hold' ? (
              <div>
                <div style={{ width: '100%' }}>
                  <DatePicker
                    selected={startDate}
                    onChange={handleChange}
                    showTimeSelect
                    timeFormat="hh:mm aa"
                    timeIntervals={1}
                    dateFormat="Pp"
                    className="form-control dtp"
                  />
                </div>
              </div>
            ) : null}

            {/* Done Deal */}
            {onetype_of_stage &&
            onetype_of_stage.stagetype &&
            onetype_of_stage.stagetype.name === 'Done Deal' ? (
              <div>
                {/* <div style={{ width: '100%' }}>
                  <DatePicker
                    selected={startDate}
                    onChange={handleChange}
                    showTimeSelect
                    timeFormat="hh:mm aa"
                    timeIntervals={1}
                    dateFormat="Pp"
                    className="form-control dtp"
                  />
                </div> */}

                {/* حقل سعر الوحدة */}

                <div className="mt-3">
                  <FormControl fullWidth margin="normal">
                    <TextField
                      id="unit-price"
                      label="Unit Price"
                      type="number"
                      value={unitPrice}
                      onChange={handlePriceChange}
                      variant="outlined"
                      required
                      error={!isPriceValid && unitPrice !== ''}
                      helperText={
                        !isPriceValid && unitPrice !== ''
                          ? 'Please Put Unit Price Here'
                          : unitPrice === ''
                            ? 'Please Put Unit Price Here'
                            : ''
                      }
                      inputProps={{
                        min: 0.01,
                        step: 0.01,
                      }}
                    />
                  </FormControl>
                </div>

                {/* unit number */}
                <div className="mt-3">
                  <FormControl fullWidth margin="normal">
                    <TextField
                      id="unitnumber"
                      label="Unit Number"
                      type="text"
                      value={unitnumber}
                      onChange={handleunitnumber}
                      variant="outlined"
                      required
                      error={!isunitnumberValid && unitnumber !== ''}
                      helperText={
                        !isunitnumberValid && unitnumber !== ''
                          ? 'Please Put Unit Number Here'
                          : isunitnumberValid === ''
                            ? 'Please Put Unit Number Here'
                            : ''
                      }
                    />
                  </FormControl>
                </div>

                {/* commission ratio */}
                <div className="mt-3">
                  <FormControl fullWidth margin="normal">
                    <TextField
                      id="Commission-Ratio"
                      label="Commission Ratio %"
                      type="number"
                      value={commissionRatio}
                      onChange={handlecommissionratioChange}
                      variant="outlined"
                      required
                      error={!commissionratioValid && commissionRatio !== ''}
                      helperText={
                        !commissionratioValid && commissionRatio !== ''
                          ? 'Please Put Commission Ratio  Here'
                          : commissionRatio === ''
                            ? 'Please Put Commission Ratio  Here'
                            : ''
                      }
                      inputProps={{
                        min: 0.01,
                        step: 0.01,
                      }}
                    />
                  </FormControl>
                </div>

                {/* company commission */}
                <TextField
                  label="Company Commission"
                  value={totalCommission}
                  disabled
                  fullWidth
                  margin="normal"
                />

                {/* cashback ratio */}
                <div className="mt-3">
                  <FormControl fullWidth margin="normal">
                    <TextField
                      id="cashback-Ratio"
                      label="cashback Ratio %"
                      type="number"
                      value={cashbackratio}
                      onChange={handlecashbackratiochange}
                      variant="outlined"
                      required
                      error={cahbackratiovalid && cashbackratio !== ''}
                      helperText={
                        !cahbackratiovalid && cashbackratio !== ''
                          ? 'Please Put Cashback Ratio  Here'
                          : cashbackratio === ''
                            ? 'Please Put Cashback Ratio  Here'
                            : ''
                      }
                      inputProps={{
                        min: 0.01,
                        step: 0.01,
                      }}
                    />
                  </FormControl>
                </div>

                {/* Cashback money */}
                <TextField
                  label="Cashback Money"
                  value={cashbackMoney}
                  disabled
                  fullWidth
                  margin="normal"
                />
              </div>
            ) : null}

            {/* Follow */}
            {onetype_of_stage &&
            onetype_of_stage.stagetype &&
            onetype_of_stage.stagetype.name === 'Follow' ? (
              <div>
                <div style={{ width: '100%' }}>
                  <DatePicker
                    selected={startDate}
                    onChange={handleChange}
                    showTimeSelect
                    timeFormat="hh:mm aa"
                    timeIntervals={1}
                    dateFormat="Pp"
                    className="form-control dtp"
                  />
                </div>
              </div>
            ) : null}

            {/* Meeting */}
            {onetype_of_stage &&
            onetype_of_stage.stagetype &&
            onetype_of_stage.stagetype.name === 'Meeting' ? (
              <div>
                <div style={{ width: '100%' }}>
                  <DatePicker
                    selected={startDate}
                    onChange={handleChange}
                    showTimeSelect
                    timeFormat="hh:mm aa"
                    timeIntervals={1}
                    dateFormat="Pp"
                    className="form-control dtp"
                  />
                </div>
              </div>
            ) : null}

            {/* Reschedual Meeting */}
            {onetype_of_stage &&
            onetype_of_stage.stagetype &&
            onetype_of_stage.stagetype.name === 'Reschedual Meeting' ? (
              <div>
                <div style={{ width: '100%' }}>
                  <DatePicker
                    selected={startDate}
                    onChange={handleChange}
                    showTimeSelect
                    timeFormat="hh:mm aa"
                    timeIntervals={1}
                    dateFormat="Pp"
                    className="form-control dtp"
                  />
                </div>
              </div>
            ) : null}

            {/* Cancellation */}
            {onetype_of_stage &&
            onetype_of_stage.stagetype &&
            onetype_of_stage.stagetype.name === 'Cancellation' ? (
              <div>
                <div style={{ width: '100%' }}>
                  <FormControl
                    onChange={CancelReasonschange}
                    fullWidth
                    style={{ marginTop: '7px' }}
                  >
                    <InputLabel id="select-label-cancelreason">Choose reason</InputLabel>
                    <Select
                      labelId="select-label-cancelreason"
                      id="select1"
                      value={cancelreason}
                      onChange={CancelReasonschange}
                      label="Choose Cancel Reason"
                    >
                      {res_allcancelreasons_array
                        ? res_allcancelreasons_array.map((item, index) => {
                            return (
                              <MenuItem value={item._id} key={index}>
                                {item.cancelreason}
                              </MenuItem>
                            );
                          })
                        : null}
                    </Select>
                  </FormControl>
                </div>
              </div>
            ) : null}

            {(onetype_of_stage?.stagetype?.name !== 'Done Deal' ||
              (unitPrice !== '' &&
                unitPrice !== null &&
                unitnumber !== '' &&
                commissionRatio !== '' &&
                commissionRatio !== null &&
                cashbackratio !== '' &&
                cashbackratio !== null)) && (
              <button
                className={`btn w-100 my-3 ${isSubmitDisabled ? 'btn-secondary' : 'btn-primary'}`}
                style={{
                  background: isSubmitDisabled ? '#6c757d' : '#102dff',
                  border: 'none',
                  cursor: isSubmitDisabled ? 'not-allowed' : 'pointer',
                  opacity: isSubmitDisabled ? 0.7 : 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '6px',
                }}
                onClick={updatestage}
                disabled={isSubmitDisabled || loading}
              >
                {loading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    Loading...
                  </>
                ) : (
                  <>
                    Submit <DoneIcon />
                  </>
                )}
              </button>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};
